import { Box, Paper } from '@mui/material';
import React from 'react';
import JsxParser from 'react-jsx-parser';
import GlobalStyles from './GlobalStyles';
import useIsIframe from '../../../hooks/useIsIframe';

export default function EventDetails({ details }) {
  const isIframe = useIsIframe();
  const frontendSettings = details?.event?.frontendSettings || {};
  const customCss = frontendSettings.customCss || frontendSettings.customCSS || '';
  const fonts = frontendSettings.fonts || frontendSettings.font || null;

  return (
    <>
      <GlobalStyles
        colors={details?.event?.colors}
        customCss={customCss}
        fonts={fonts}
      />
      {!isIframe && details.event?.logoUrl && (
        <Box sx={{ maxWidth: 800, mx: 'auto', my: 2, textAlign: 'center' }}>
          <img src={details.event?.logoUrl} alt="logo" style={{ width: '80%' }} />
        </Box>
      )}
      {!isIframe && details?.event?.description && (
        <Paper sx={{ maxWidth: 800, boxShadow: 3, p: 4, mx: 'auto', mb: 4 }}>
          <Box sx={{ padding: 4, maxWidth: 800, margin: 'auto', paddingTop: 0 }}>
            <JsxParser
              jsx={details?.event?.description}
              autoCloseVoidElements
            />
          </Box>
        </Paper>
      )}
    </>
  );
}
